import React, { Component, Fragment } from "react";
import { connect } from 'react-redux';
import * as authConstants from "../../actions";
import { Auth } from "aws-amplify";
import { Link, withRouter } from "react-router-dom";
import Routes from "../../Routes";
import Crisis from "../header/Crisis";
import Header from "../header/Header";
import Hero from "../header/Hero";
import Layout from "../layout/Layout";
import Quote from "../footer/Quote";
import Footer from "../footer/Footer";

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.session.isAuthenticated,
    isAuthenticating: state.session.isAuthenticating,
    user: state.session.user
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    refreshSession: (user) => {
      console.log('dispatching session state', user);
      dispatch({ type: 'LOGIN_USER_SUCCESS', user });
    }
  }
}

class RootContainer extends Component {

  constructor(props) {
    super(props);
    console.log('root props:', props);
    this.props = props;
  }

  async componentDidMount() {
    try {
      if (await Auth.currentSession()) {
        this.userHasAuthenticated(true);
        await Auth.currentUserInfo().then(result => this.props.refreshSession(result));
      }
    } catch (e) {
      console.log('no current session: ', e);
      if (e !== 'No current user') {
        alert(e);
      }
    }

    this.setState({ isAuthenticating: false });
  }

  userHasAuthenticated = authenticated => {
    this.setState({ isAuthenticated: authenticated });
  };

  // handleLogout = async event => {
  //   await Auth.signOut();
  //   this.userHasAuthenticated(false);
  //   // resetting the user on logout
  //   this.setState({ user: {} });
  //
  //   this.props.history.push('/');
  // }

  render() {
    //childProps passed into routes like a directive param
    const childProps = {
      isAuthenticated: this.props.isAuthenticated,
      userHasAuthenticated: this.props.userHasAuthenticated,
      user: this.props.user
    };
    return (
      <div className="App container-fluid">
        <div className="row">
          <Routes childProps={childProps} />
          <Footer />
        </div>
      </div>
    );
    // TODO:: just commenting this out as i think hero, crisis etc should be in layouts so they are custom
    // and i guess the Route should call the layout? 
    //   <div className="App container-fluid">
    //   <div className="row">
    //     <Header/>
    //     <Hero />
    //     <Crisis />
    //     <div className="arrow-down"></div>
    //     <Routes childProps={childProps} />
    //     <Layout name="home" />
    //     <Quote />
    //     <Footer />
    //   </div>
    // </div>
    //
    // return (
    //   !this.state.isAuthenticating &&
    //   <div className="App container-fluid">
    //     <div className="row">
    //       <Header childProps={childProps}/>
    //       <Hero />
    //       <Crisis />
    //         <div className="arrow-down"></div>
    //       <Routes childProps={childProps} />
    //       <Layout name="home" />
    //       <Quote />
    //       <Footer />
    //     </div>
    //   </div>
    // );
  }
}
//export default withRouter(App);
export default connect(mapStateToProps, mapDispatchToProps)(RootContainer);



// WEBPACK FOOTER //
// ./src/containers/root/index.js